import { useRef } from 'react'
import { useFocusOnMount } from '../../../Framework/View/Hooks/useFocusOnMount.ts'
import { Callout } from './Primitives.tsx'

/** Asked before leaving Samples & controls with pool moves not applied. */
export const LeavePrompt = ({ onApply, onDiscard, onStay }: { onApply: () => void; onDiscard: () => void; onStay: () => void }) => {
  const apply = useRef<HTMLButtonElement>(null)
  useFocusOnMount(apply)
  return (
    <Callout
      role="group"
      aria-label="Unapplied pool changes"
      className="flex w-full flex-wrap items-center gap-2 rounded bg-amber-50 px-2 py-1.5 text-sm"
      data-testid="wizard-leave-prompt"
      onKeyDown={(event) => event.key === 'Escape' && onStay()}
    >
      <span className="text-slate-800">Apply the pool changes?</span>
      <button ref={apply} type="button" className="btn btn-sm btn-primary" data-testid="wizard-leave-apply" onClick={onApply}>
        Use these pools
      </button>
      <button type="button" className="btn btn-sm" data-testid="wizard-leave-discard" onClick={onDiscard}>
        Discard
      </button>
      <button type="button" className="btn btn-sm btn-ghost" data-testid="wizard-leave-stay" onClick={onStay}>
        Stay
      </button>
    </Callout>
  )
}
